<template>
  <div class="main">
    <div class="top_back">
      <DivTop :active='5' />
      <div class="w120 bj_box">
        <span>第三方资源中心</span>
        <span>金飞鹰科技以行业应用系统开发为主的高科技软件企业</span>
      </div>
    </div>
    <div class="third_box">
        <div class="w120">
        
            <div class="one">
              <div class="core_top">
                <span>客户端</span>
                <img src="@/assets/nav.png" alt="">
              </div>
              <div class="box_content">
                <a :href="item.href" target="_blank" v-for="(item,index) in arr1" :key="index">
                    <div class="tops">
                      <span>{{item.name}}</span>
                      <div>个人认证</div>
                    </div>
                    <span>{{item.txt}}</span>
                    <div class="bottom">
                      <span>{{item.ti}}</span>
                      <div>
                        百度云下载
                      </div>
                    </div>
                </a>
                <div ></div>
              </div>
            </div>
       
        </div>
    </div>
    <Divfooter />
  </div>
</template>
<script>
export default {
  data(){
    return{
    
      arr1:[
        {
          name:'服务端、客户端文档',
          txt:'服务端、客户端文档'  ,
          ti:'提取码：xfrp',
          href:'https://pan.baidu.com/s/1Ew2i9xXlAqklVGSh8EFWkw?pwd=xfrp'
        },
        {
          name:'金飞鹰内管系统常见问题2019',
          txt:'金飞鹰内管系统常见问题'  ,
          ti:'提取码：3b4x',
          href:'https://pan.baidu.com/s/1zqBeSpdxF-GHImZMDX0m9A?pwd=3b4x'
        },
        {
          name:'2024-金飞鹰雪务通系统常见问题',
          txt:'2024-金飞鹰雪务通系统常见问题'  ,
          ti:'提取码：173i',
          href:'https://pan.baidu.com/s/1Irf6wq2mIVxupV3cudR2uw?pwd=173i'
        },
        {
          name:'2023培训内容',
          txt:'2023培训内容'  ,
          ti:'提取码：jsyr',
          href:'https://pan.baidu.com/s/1DEmtiRluSiHMBg_gb2rs1A?pwd=jsyr'
        },
        {
          name:'2019金飞鹰硬件产品',
          txt:'2019金飞鹰硬件产品'  ,
          ti:'提取码：bz0g',
          href:'https://pan.baidu.com/s/1GIQ9GycncyWg0udjjj50_w?pwd=bz0g'
        },
      ],
    
    }
  }
}
</script>
<style lang="less" scoped>
.main{
  width: 100%;
  .top_back{
    width: 100%;
    height: 42.8rem;
    background: url(../../assets/black.png) no-repeat;
    background-size: 100% 100%;
  }
  .bj_box{
    padding: 19.3rem 0 0 0;
    box-sizing: border-box;
    >span{
      color: #fff;
      font-size: 4.6rem;
      &:nth-child(2){
        display: block;
        margin-top: 1.6rem;
        font-size: 1.6rem;
      }
    }
  }
  .third_box{
    padding: 9.4rem 0 10rem 0;
    box-sizing: border-box;
    background: #F6F9FC;
    .one{
      margin-top: 10rem;
      &:nth-child(1){
        margin-top: 0;
      }
      .core_top{
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          span{
            font-size: 3.6rem;
            color: #333B47;
          }
          img{
            width: 3.27rem;
            height: 1.169rem;
            margin-top: .7rem;
          }
      }
      .box_content{
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-top: 6rem;
        >a{
          width: 39rem;
          height: 20rem;
          background: #FFFFFF;
          margin-bottom: 1.5rem;
          display: flex;
          flex-direction: column;
          padding: 3rem;
          box-sizing: border-box;
          >span{
            color: #999999;
            font-size: 1.6rem;
            display: block;
            margin-top: 1.5rem;
          }
          .tops{
            display: flex;
            justify-content: space-between;
            >span{
              color: #333333;
              font-size: 2rem;
              font-weight: 600;
            }
            >div{
              width: 6rem;
              height: 2rem;
              color: #E86F00;
              background: #FFF0C5;
              font-size: 1.2rem;
              border-radius: 0.4rem;
              display: flex;
              justify-content: center;
              align-items: center;
            }
          }
          .bottom{
            display: flex;
            justify-content: space-between;
            margin-top: auto;
            align-items: center;
            span{
              color: #999999;
              font-size: 1.6rem;
            }
            div{
              width: 14rem;
              height: 3.8rem;
              border: 1px solid #E86F00;
              display: flex;
              justify-content: center;
              align-items: center;
              color: #E86F00;
              font-size: 1.6rem;
            }
          }
        }
        >div{
          width: 39rem;
          height: 20rem;
        }
      }
    }
  }
}
</style>